export const LEGAL_DEADLINE_DAYS = 7;
const DAY_MS = 86_400_000;

export type DeadlineStatus = "invalid" | "future" | "within" | "expired";

export interface DeadlineResult {
  status: DeadlineStatus;
  days: number;
}

export function parseLocalDate(iso: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return null;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const date = new Date(y, mo - 1, d);
  if (date.getFullYear() !== y || date.getMonth() !== mo - 1 || date.getDate() !== d) return null;
  return date;
}

const startOfLocalDay = (d: Date): Date => new Date(d.getFullYear(), d.getMonth(), d.getDate());

export function daysElapsed(signed: Date, now: Date): number {
  return Math.round((startOfLocalDay(now).getTime() - startOfLocalDay(signed).getTime()) / DAY_MS);
}

export function evaluateDeadline(iso: string, now: Date = new Date()): DeadlineResult {
  const signed = parseLocalDate(iso);
  if (!signed) return { status: "invalid", days: 0 };
  const days = daysElapsed(signed, now);
  if (days < 0) return { status: "future", days };
  return { status: days <= LEGAL_DEADLINE_DAYS ? "within" : "expired", days };
}

export function todayISO(now: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}
